export default "__VITE_ASSET__DOceiP3c__"